import React from 'react';

import Spinner from './Spinner';

const IubendaViewer = ({ policyUrl, cypressId }: { policyUrl: string; cypressId?: string }) => {
  const [content, setContent] = React.useState<string>(null);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    void fetch(policyUrl)
      .then((response) => response.json())
      .finally(() => setLoading(false))
      .then((data) => {
        if (data && data.success) {
          setContent(data.content);
        }
      });
  });

  if (loading) {
    return <Spinner />;
  }
  if (content) {
    // eslint-disable-next-line react/no-danger
    return <div data-cy={cypressId} dangerouslySetInnerHTML={{ __html: content }} />;
  }
  return (
    <div>
      Please see the policy at <a href={policyUrl}>{policyUrl}</a>
    </div>
  );
};

export default IubendaViewer;
